var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off",
    clipPath: "url(#clip0_1756_28437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7673 11.7668C11.5384 12.0125 11.2624 12.2095 10.9558 12.3461C10.6491 12.4828 10.3181 12.5562 9.98239 12.5622C9.64672 12.5681 9.31329 12.5063 9.00199 12.3806C8.6907 12.2549 8.40792 12.0677 8.17052 11.8303C7.93313 11.5929 7.74598 11.3101 7.62024 10.9988C7.4945 10.6875 7.43276 10.3541 7.43868 10.0184C7.4446 9.68277 7.51807 9.35172 7.65471 9.04506C7.79135 8.73839 7.98836 8.46239 8.23398 8.23352M14.9507 14.9502C13.5261 16.036 11.7916 16.6376 10.0007 16.6668C4.16732 16.6668 0.833984 10.0002 0.833984 10.0002C1.87056 8.06843 3.30826 6.38069 5.05065 5.05018L14.9507 14.9502ZM8.25065 3.53352C8.82426 3.39925 9.41154 3.33213 10.0007 3.33352C15.834 3.33352 19.1673 10.0002 19.1673 10.0002C18.6615 10.9465 18.0582 11.8375 17.3673 12.6585L8.25065 3.53352Z",
    stroke: "#424244",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.833984 0.833496L19.1673 19.1668",
    stroke: "#424244",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1756_28437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.ac3b7935e91697a1fd68b20c214674ec.svg";
export { ForwardRef as ReactComponent };